// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import {Loading,Message } from 'element-ui'
import Axios from 'axios'
import qs from 'qs'
import VueAxios from 'vue-axios'
import loki from 'lokijs'
import * as rrweb from 'rrweb'
// import rrwebPlayer from 'rrweb-player'
import App from './App'
import router from './router'
import $$ from './tool/BaseXJT.js'
import chinaLifeAccidentDistrict from "./tool/chinaLifeAccidentDistrict.js"
import sinosafeAccidentDistrict from "./tool/sinosafeAccidentDistrict.js"
import orderHelper from '../static/js/order/orderHelper.js'
import ls from './tool/sessionStorage.js'
import ejsinoProElementInfo from './tool/ejsinoProElementInfo.js'
import screenRecBase from './tool/milibao/screenRecBase.js'
import UrlConfig from './tool/UrlConfig.js'
import Mint from 'mint-ui'
import vant from 'vant'
import * as imageConversion from 'image-conversion'
import jsencrypt from '../static/js/jsencrypt.js'

// 导入jquery和bootstrap
import 'jquery/dist/jquery.min'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'element-ui/lib/theme-chalk/index.css'
import "vant/lib/index.css"

/* 导入公共css和js */
import '../static/css/reset.css'
import '../static/css/dutyInsurance/outerFrame.css'
import baseUrl from './tool/baseUrl'
import 'mint-ui/lib/style.css'

Vue.prototype.ls = ls;
Vue.prototype.loki = loki;
Vue.prototype.rrweb = rrweb;
// Vue.prototype.rrwebPlayer = rrwebPlayer;
Vue.prototype.orderHelper = orderHelper;
Vue.prototype.screenRecBase = screenRecBase;
Vue.prototype.chinaLifeAccidentDistrict = chinaLifeAccidentDistrict;
Vue.prototype.ejsinoProElementInfo = ejsinoProElementInfo;
Vue.prototype.sinosafeAccidentDistrict = sinosafeAccidentDistrict;
Vue.prototype.Loading = Loading;
Vue.prototype.qs = qs;
// Vue.prototype.returnCitySN = returnCitySN;
Vue.prototype.$$ = $$;
Vue.prototype.UrlConfig = UrlConfig;
Vue.prototype.jsencrypt = jsencrypt;
Vue.config.productionTip = false;
Vue.use(VueAxios, Axios);
Vue.use(ElementUI);
Vue.use(Mint);
Vue.use(vant);
Vue.prototype.imageConversion = imageConversion;

router.beforeEach((to, from, next) => {
  let token = $$.localStorageGet($$.constant.tokenKey + '_TIMING');
  //配置接口信息
  Axios.defaults.baseURL = baseUrl.rootUrl;

  if (token) {
    Axios.defaults.headers.common[$$.constant.tokenKey] = token;
    next();
	}else{
    next();
  }

  // response interceptor（接收拦截器）
  Axios.interceptors.response.use(function (response) {
    return response;
  }, error => {
    let response = error.response;
    const status = response.status;
    switch (status) {
      case 401:{
        Message.error("系统超时，请重新登录！");
        // 判断状态码是401 跳转到登录
        router.push({name: "login" });
        localStorage.removeItem($$.constant.tokenKey + '_TIMING');
        Axios.defaults.headers.common[$$.constant.tokenKey] = null;
        break;
      }
      // 自动退出接口返回状态码
      case 520:
        Message.error("系统超时，请重新登录！");
        router.push({name: "login" });
        localStorage.removeItem($$.constant.tokenKey + '_TIMING');
        Axios.defaults.headers.common[$$.constant.tokenKey] = null;
        break;
    }
    return {
      data: {
        data: '',
        error: "请重新登录"
      }
    };
  });

  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
});

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js